import AtriumApi, { getApiErrorMessage } from "api";
import Loader from "components/loader/Loader";
import { PageContainer, PageHeader } from "components/page";
import notify from "lib/notify";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const PCIntegrationRedirecting = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const code = searchParams.get("code");

  useEffect(() => {
    if (code) {
      createPlaningCenterConnection({ code: code });
    }
  }, [code]);

  const createPlaningCenterConnection = async (payload) => {
    try {
      const response = await AtriumApi.post("/v1/access-token", payload);
      if (response?.data?.access_token) {
        notify.success("Connected to Planning Center");
      }
    } catch (error) {
      notify.error(getApiErrorMessage(error, "Could not connect to Planning Center"));
    } finally {
      navigate("/admin/settings?tab=integrations");
    }
  };

  return (
    <PageContainer variant="narrow">
      <PageHeader
        title="Planning Center Integration"
        description="Finishing the connection to Planning Center. You will be returned to Settings shortly."
      />
      <Loader label="Connecting to Planning Center" />
    </PageContainer>
  );
};

export default PCIntegrationRedirecting;
